'use strict';
angular.module("iconoglobe")
    .config(['$stateProvider', "$urlRouterProvider", '$locationProvider', 'APP_VERSION', function ($stateProvider, $urlRouterProvider, $locationProvider, APP_VERSION) {

      $stateProvider
   .state('maps', {
     templateUrl: 'app/min/maps.html',
     controller: "MapCtrl"
   })
             .state('maps.world', {
                 url: '/',            
                 templateUrl: 'app/min/jsonmap.html?'+APP_VERSION.version,
 		        controller: "MapCtrl",
 

             })
             .state('maps.world.promoteruser', {
                 url: '/promoterEvents/:userid',
                 templateUrl: 'app/min/world.html?'+APP_VERSION.version,
                 controller: "MapLayoutCtrl"
             })
             .state('mobile', {
                 url: '/mobile',
                 templateUrl: 'app/min/maps.html?'+APP_VERSION.version,
                 controller: "MapCtrlMobile"
             })
             .state('maps.discover', {
                 url: '/discover',
               templateUrl: 'app/min/jsonmap.html?'+APP_VERSION.version,
 		        controller: "MapCtrl",
 		         resolve: {
                 loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/MapCtrlMobile.js?'+APP_VERSION.version]);
                     }]
 }
 
            })
											   
			 .state('maps.channel', {
                url: '/channel/:slug',
                templateUrl: 'app/min/jsonmap.html?' + APP_VERSION.version,
                controller: 'MapCtrl'
            })							   
																				  
										   
			  
							  
							   
																						
										
			  
									 
								 
																				  
								
 
			 
 		              .state('tickets', {
 				url: '/tickets',
              templateUrl: 'app/min/tickets.html?'+APP_VERSION.version,
 		        controller: 'tcktCtrl',
               resolve: {
                 loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/tcktCtrl.js?'+APP_VERSION.version,'app/js/controllers/swiper-bundle.min.js?'+APP_VERSION.version]);
                     }]
 }

             })
             .state("base", {
                 templateUrl: 'app/min/base.html?'+APP_VERSION.version,
                 controller: 'BaseCtrl',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/BaseCtrl.js?'+APP_VERSION.version]);
                     }]
                 }
             })
             .state("base.cropping", {
                 url: '/cropping',
                 templateUrl: 'app/min/cropping.html?'+APP_VERSION.version,
                controller: 'cropImage',
 			   resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/libs/Croppie/croppie.js?'+APP_VERSION.version]);
                     }]
                 }
             })
             .state("base.signup", {
                 url: '/signup',
                 templateUrl: 'app/min/signup.html?'+APP_VERSION.version,
                 controller: 'RegCtrl',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/RegCtrl.js?'+APP_VERSION.version,
                             'app/js/directives/verifyusername.js?'+APP_VERSION.version,
                             'app/js/directives/mbplaceformsignup.js?'+APP_VERSION.version]);
                     }]
                 }
             })
 			            .state("baseinv", {
                 templateUrl: 'app/min/baseinv.html?'+APP_VERSION.version,
                 controller: 'LoginCtrl'
             })
			
 			            .state("baseinv.invest", {
                 url: '/invest',
                 templateUrl: 'app/min/invest.html?'+APP_VERSION.version,
                 controller: 'LoginCtrl'
             })
 			 .state("baseinv.teamup", {
                 url: '/teamup',
                 templateUrl: 'app/min/teamup.html?'+APP_VERSION.version,
                 controller: 'LoginCtrl'
             })
             .state("base.mediacoverage", {
                 url: '/mediacoverage',
                 templateUrl: 'app/min/mediacoverage.html?'+APP_VERSION.version,
             })
             .state("base.mediaasia", {
                 url: '/media/asia',
                 templateUrl: 'app/min/mediaasia.html?'+APP_VERSION.version,
             })
             .state("base.mediaafrica", {
                 url: '/media/africa',
                 templateUrl: 'app/min/mediaafrica.html?'+APP_VERSION.version,
             })
             .state("base.mediamiddleeastasia", {
                 url: '/media/middleeastasia',
                 templateUrl: 'app/min/mediamiddleeastasia.html?'+APP_VERSION.version,
             })
             .state("base.mediaeurope", {
                 url: '/media/europe',
                 templateUrl: 'app/min/mediaeurope.html?'+APP_VERSION.version,
             })
             .state("base.mediasamerica", {
                 url: '/media/samerica',
                 templateUrl: 'app/min/mediasamerica.html?'+APP_VERSION.version,
             })
             .state("base.medianamerica", {
                 url: '/media/namerica',
                 templateUrl: 'app/min/medianamerica.html?'+APP_VERSION.version,
             })
             .state("base.login", {
                 url: '/login',
                 templateUrl: 'app/min/login.html?'+APP_VERSION.version,
                 controller: 'LoginCtrl'
             })
             .state('base.thankyou', {
                 url: "/thankyou",
                 templateUrl: 'app/min/thankyou.html?'+APP_VERSION.version,
             })
             .state('base.forgetpassword', {
                 url: "/forgetpassword",
                 templateUrl: 'app/min/forgetpassword.html?'+APP_VERSION.version,
                 controller: 'LoginCtrl'
             })
             .state('base.resetpasswordidcode', {
                 url: '/resetpassword/:id/:code',
                 templateUrl: 'app/min/resetpassword.html?'+APP_VERSION.version,
                 controller: 'LoginCtrl'
             })
             .state('base.termsofuse', {
                 url: '/terms-of-use',
                 templateUrl: 'app/min/terms.html?'+APP_VERSION.version
             })
             .state('base.advertisingterms', {
                 url: '/advertising-terms-of-use',
                 templateUrl: 'app/min/iconoglobe-ad-terms.html?'+APP_VERSION.version,
             })
             .state('base.career', {
                 url: "/career",
                 templateUrl: 'app/min/career.html?'+APP_VERSION.version
             })
             .state('base.claimyourprofile', {
                 url: "/claimyourprofile",
                 templateUrl: 'app/min/claimprofile.html?'+APP_VERSION.version
             })
             .state('base.press', {
                 url: '/press',
                 templateUrl: 'app/min/press.html?'+APP_VERSION.version
             })
             .state('base.aboutus', {
                 url: '/about-us',
                 templateUrl: 'app/min/about-us.html?'+APP_VERSION.version
             })
             .state('base.iconoglobemobile', {
                 url: '/iconoglobe-mobile',
                 templateUrl: 'app/min/iconoglobe-mobile.html?'+APP_VERSION.version
             })
             .state('base.guidelinespolicies', {
                 url: '/guidelines-policies',
                 templateUrl: 'app/min/guidelines-policies.html?'+APP_VERSION.version
             })
            .state('base.businesssupport', {
                 url: '/business-support',
                 templateUrl: 'app/min/business-support.html?'+APP_VERSION.version
             })
             .state('base.individualsupport', {
                 url: '/individual-support',
                 templateUrl: 'app/min/individual-support.html?'+APP_VERSION.version
             })
             .state('base.contentguideline', {
                 url: '/content-guideline',
                 templateUrl: 'app/min/content-guideline.html?'+APP_VERSION.version
             })
             .state('base.businesslisticonoglobe', {
                 url: '/business-list-iconoglobe',
                 templateUrl: 'app/min/business-list-iconoglobe.html?'+APP_VERSION.version
             })
             .state('base.privacypolicy', {
                 url: '/privacy-policy',
                 templateUrl: 'app/min/privacy.html?'+APP_VERSION.version
             })
             .state('base.sitemap', {
                 url: '/sitemap',
                 templateUrl: 'app/min/sitemap.html?'+APP_VERSION.version,
                 // controller: 'sitemap'

             })
             .state('base.contactus', {
                 url: '/contact-us',
                 templateUrl: 'app/min/contact-us.html?'+APP_VERSION.version,
                 controller: 'LoginCtrl'
             })
              .state('base.advertisewithus', {
                 url: '/advertisewithus',
                 templateUrl: 'app/min/promotionlayout2.html?'+APP_VERSION.version,
                 controller: 'PromotionsController2',
 				 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/PromotionsController2.js?'+APP_VERSION.version
 						]);
                     }]
                 }
                
             })

 
             // user state routes
             .state("user", {
                 templateUrl: 'app/min/user.html',
                 controller: 'UserCtrl',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/ConfirmInstanceCtrl.js?'+APP_VERSION.version,
 						    'app/js/controllers/UserCtrl.js?'+APP_VERSION.version,
                             'app/js/controllers/FileUploadController.js?'+APP_VERSION.version,
                             'app/js/controllers/UploadPhotosController.js?'+APP_VERSION.version,
                             'app/js/controllers/UploadAudiosController.js?'+APP_VERSION.version,
                             'app/js/controllers/UploadVideosController.js?'+APP_VERSION.version,
                             'app/libs/lodash.min.js?'+APP_VERSION.version,
                             'app/libs/Croppie/croppie.js?'+APP_VERSION.version, "https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"]);
                     }]
                 }
             })
 		 .state("user2", {
                 templateUrl: 'app/min/user2.html',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/ConfirmInstanceCtrl.js?'+APP_VERSION.version,
                             'app/js/controllers/FileUploadController.js?'+APP_VERSION.version,
                             'app/js/controllers/UploadPhotosController.js?'+APP_VERSION.version,
                             'app/js/controllers/UploadAudiosController.js?'+APP_VERSION.version,
                             'app/js/controllers/UploadVideosController.js?'+APP_VERSION.version,
                             'app/libs/lodash.min.js?'+APP_VERSION.version,
                             'app/libs/Croppie/croppie.js?'+APP_VERSION.version, "https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"]);
                     }]
                 }
             })
         
             .state("user.profile", {
                 url: "/profile",
                 templateUrl: 'app/min/profile.html?'+APP_VERSION.version,
                 controller: 'ProfileController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/ProfileController.js?'+APP_VERSION.version,
                             'app/js/directives/googleplaceformesta.js?'+APP_VERSION.version,
 							'app/js/directives/cropsingleimage.js?'+APP_VERSION.version,
 							'app/libs/qr-code-styling.js?'+APP_VERSION.version]);
                     }]
                 }
             })
             .state('user.uploadphotos', {
                 url: "/uploadphotos",
                 templateUrl: 'app/min/uploadphotos.html?'+APP_VERSION.version,
                 controller: 'UploadPhotosController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load('app/js/controllers/UploadPhotosController.js?'+APP_VERSION.version);
                     }]
                 }
             })
             .state('user.uploadaudios', {
                 url: "/uploadaudios",
                 templateUrl: 'app/min/uploadaudios.html?'+APP_VERSION.version,
                 controller: 'UploadAudiosController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load('app/js/controllers/UploadAudiosController.js?'+APP_VERSION.version);
                     }]
                 }
             })
             .state('user.uploadvideos', {
                 url: "/uploadvideos",
                 templateUrl: 'app/min/uploadvideos.html?'+APP_VERSION.version,
                 controller: 'UploadVideosController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load('app/js/controllers/UploadVideosController.js?'+APP_VERSION.version);
                     }]
                 }
             })
             .state('user.additionalusers', {
                 url: '/additionalusers',
                 templateUrl: 'app/min/additionalusers.html?'+APP_VERSION.version,
                 controller: 'ManagerController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/ManagerController.js?'+APP_VERSION.version, 'app/js/directives/simplePagination.js?'+APP_VERSION.version]);
                     }]
                 }
             })
             .state('user.entertainment', {
                 url: '/entertainment',
                 templateUrl: 'app/min/viewestablish.html?'+APP_VERSION.version,
                 controller: 'EstablishController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/EstablishListCtrl.js?'+APP_VERSION.version,'app/libs/qr-code-styling.js?'+APP_VERSION.version]);
                     }]
                 }
             })

             .state('user.addevent', {
                 url: '/addevent',
                 templateUrl: 'app/min/addevent.html?'+APP_VERSION.version,
                 controller: 'EventsController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/AddEventCtrl.js?'+APP_VERSION.version,
                             'app/js/directives/hideinstructreach.js?'+APP_VERSION.version,
                             'app/js/directives/mbestplace.js?'+APP_VERSION.version,
                             'app/js/controllers/IndividualeventController.js?'+APP_VERSION.version]);
                     }]
                 }
             })
             .state('user.eventview', {
                 url: '/eventview',
                 templateUrl: 'app/min/eventview.html?'+APP_VERSION.version,
                 controller: 'EventviewController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/EventListCtrl.js?'+APP_VERSION.version,
                             'app/js/directives/hideinstructreach.js?'+APP_VERSION.version,
                             'app/js/directives/googleplaceaddress.js?'+APP_VERSION.version,
 							'app/libs/qr-code-styling.js?'+APP_VERSION.version]);
                     }]
                 }
             })
 			  .state('user.ineventview', {
                 url: '/ineventview',
                 templateUrl: 'app/min/ineventview.html?'+APP_VERSION.version,
                 controller: 'EventviewController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/EventListCtrl.js?'+APP_VERSION.version,
                             'app/js/directives/hideinstructreach.js?'+APP_VERSION.version,
                             'app/js/directives/googleplaceaddress.js?'+APP_VERSION.version,
 							'app/libs/qr-code-styling.js?'+APP_VERSION.version]);
                     }]
                 }
             })
             .state('user.eventeditid', {
                 url: '/eventedit/:id',
                 templateUrl: 'app/min/eventedit.html?'+APP_VERSION.version,
                 controller: 'EventseditController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/EditEventController.js?'+APP_VERSION.version,
                             'app/js/directives/hideinstructreach.js?'+APP_VERSION.version,
                             'app/js/directives/googleplaceaddress.js?'+APP_VERSION.version,
                             'app/js/directives/googleplaceformesta.js?'+APP_VERSION.version]);
                     }]
                 }
             })
        
             .state('user.liveeventid', {
                 url: '/liveevent/:id',
                 templateUrl: 'app/min/liveevent.html?'+APP_VERSION.version,
                 controller: 'VidEventseditController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/VidEditEventController.js?'+APP_VERSION.version,
                             'app/js/directives/hideinstructreach.js?'+APP_VERSION.version,
                             'app/js/directives/googleplaceaddress.js?'+APP_VERSION.version,
                             'app/js/directives/googleplaceformesta.js?'+APP_VERSION.version]);
                     }]
                 }
             })    
          .state('user.indivevent', {
                 url: '/indivevent/:id',
                 templateUrl: 'app/min/indivevent.html?'+APP_VERSION.version,
                 controller: 'IndivEventController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/ivs-broadcast.js?'+APP_VERSION.version,
    'app/js/controllers/IndivEventController.js?'+APP_VERSION.version,
    'app/js/directives/hideinstructreach.js?'+APP_VERSION.version,
    'app/js/directives/googleplaceaddress.js?'+APP_VERSION.version,
    'app/js/directives/googleplaceformesta.js?'+APP_VERSION.version]);
                             
                             
                               
    
    
                     }]
                 }
             }) 		
             .state('user.establishment', {
                 url: '/establishment',
                 templateUrl: 'app/min/addestablishment.html?'+APP_VERSION.version,
             })
             .state('user.addestablishment', {
                 url: '/addestablishment',
                 templateUrl: 'app/min/addesta.html?'+APP_VERSION.version,
                 controller: 'EventController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/directives/googleplaceaddress.js?'+APP_VERSION.version, 'app/js/directives/googleplacecity.js?'+APP_VERSION.version,
                             'app/js/controllers/estaiframectrl.js?'+APP_VERSION.version,
                             'app/js/controllers/AddEstablishCtrl.js?'+APP_VERSION.version,
                             'app/js/directives/mbestplace.js?'+APP_VERSION.version,
                             'app/js/directives/mbestlocation.js?'+APP_VERSION.version]);
                     }]
                 }
             })
             .state('user.editestaid', {
                 url: '/editesta/:id',
                 templateUrl: 'app/min/editesta.html?'+APP_VERSION.version,
                 controller: 'EditEstablishController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/EditEstablishCtrl.js?'+APP_VERSION.version,
                             'app/js/controllers/estaiframectrl.js?'+APP_VERSION.version, 'app/js/directives/googleplacecity.js?'+APP_VERSION.version,
                             'app/js/directives/googleplaceaddress.js?'+APP_VERSION.version,
                             'app/js/directives/mbestplace.js?'+APP_VERSION.version,
                             'app/js/directives/mbestlocation.js?'+APP_VERSION.version]);
                     }]
                 }
             })
             .state('user.livevideoid', {
                 url: '/livevideo/:id',
                 templateUrl: 'app/min/livevideo.html?'+APP_VERSION.version,
                 controller: 'VidEditEstablishController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/VidEditEstablishCtrl.js?'+APP_VERSION.version,
                             'app/js/controllers/estaiframectrl.js?'+APP_VERSION.version, 'app/js/directives/googleplacecity.js?'+APP_VERSION.version,
                             'app/js/directives/googleplaceaddress.js?'+APP_VERSION.version,
                             'app/js/directives/mbestplace.js?'+APP_VERSION.version,
                             'app/js/directives/mbestlocation.js?'+APP_VERSION.version]);
                     }]
                 }
             })
             .state('user.registerestablishment', {
                 url: '/registerestablishment',
                 templateUrl: 'app/min/registerestablishment.html?'+APP_VERSION.version,
                 controller: 'RegestablishController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/RegestablishController.js?'+APP_VERSION.version,
                             'app/js/directives/googleplaceaddress.js?'+APP_VERSION.version,
                             'app/js/directives/mbregisterestplace.js?'+APP_VERSION.version,
                             'app/js/controllers/IndividualeventController.js?'+APP_VERSION.version,
                             'app/js/directives/mbregisterestlocation.js?'+APP_VERSION.version]);
                     }]
                 }
             })
             .state('user.editestablishmentid', {
                 url: '/editestablishment/:id',
                 templateUrl: 'app/min/registerestablishment.html?'+APP_VERSION.version,
                 controller: 'RegestablishController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/RegestablishController.js?'+APP_VERSION.version,
                             'app/js/directives/googleplaceformesta.js?'+APP_VERSION.version]);
                     }]
                 }
             })
             .state('user.registerentertainment', {
                 url: '/register-entertainment',
                 templateUrl: 'app/min/individualevent.html?'+APP_VERSION.version,
                 controller: 'IndividualeventController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/directives/googleplaceaddress.js?'+APP_VERSION.version, 'app/js/controllers/IndividualeventController.js?'+APP_VERSION.version]);
                     }]
                 }
             })
             .state('user.eeprofile', {
                 url: '/ee/at/:coor/type/:type/name/:name/rD/:id',
                 templateUrl: 'app/min/eeprofileview.html',
                 resolve: {
                     redirectthis: function ($stateParams, $location, $state) {
                         console.log($state.defaultErrorHandler());
                         var type = $stateParams.type;
                         var name = $stateParams.name;
                         console.log($stateParams);
                         var search = {
                             'at': $stateParams.coor,
                             'rD': $stateParams.id
                         };
                         if (type == 'event') {
                             search.event = name;
                         } else if (type == 'related') {
                             search.related = name;
                         } else {
                             search.establishment = name;
                         }
                         console.log(search);
                         $location.path('discover').search(search);
                     }
                 }
             })
             .state('user.viewregistrations', {
                 url: '/view-registrations',
                 templateUrl: 'app/min/viewindividualevents.html?'+APP_VERSION.version,
                 controller: 'IndividualeventController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load('app/js/controllers/IndividualeventController.js?'+APP_VERSION.version);
                     }]
                 }
             })
             .state('user.registerentertainmentid', {
                 url: '/register-entertainment/:id',
                 templateUrl: 'app/min/editindividual.html?'+APP_VERSION.version,
                 controller: 'IndividualeventController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load('app/js/controllers/IndividualeventController.js?'+APP_VERSION.version);
                     }]
                 }
             })
             .state('user.comments', {
                 url: '/comments',
                 templateUrl: 'app/min/comments.html?'+APP_VERSION.version,
                 controller: 'IndividualeventController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load('app/js/controllers/IndividualeventController.js?'+APP_VERSION.version);
                     }]
                 }
             })
             .state('user.addphoto', {
                 url: '/addphoto',
                 templateUrl: 'app/min/addphoto.html?'+APP_VERSION.version,
                 controller: 'IndividualeventController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/IndividualeventController.js?'+APP_VERSION.version, 'app/js/directives/cropsingleimage.js?'+APP_VERSION.version]);
                     }]
                 }
             })
             .state('user.notify', {
                 url: '/notify',
                 templateUrl: 'app/min/notify.html?'+APP_VERSION.version,
                 controller: 'NotificationController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/NotificationController.js?'+APP_VERSION.version]);
                     }]
                 }
             })
             .state('user.addnotify', {
                 url: '/addnotify',
                 templateUrl: 'app/min/addnotify.html?'+APP_VERSION.version,
                 controller: 'NotificationController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/AddNotificationController.js?'+APP_VERSION.version, 
                             'app/js/directives/mbaddeditnotify.js?'+APP_VERSION.version,
                             'app/js/directives/mbnotifykeywordplace.js?'+APP_VERSION.version]);
                     }]
                 }
             })
             .state('user.addnotifyid', {
                 url: '/addnotify/:type/:id',
                 templateUrl: 'app/min/editgenrenotify.html?'+APP_VERSION.version,
                 controller: 'NotificationController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/NotificationController.js?'+APP_VERSION.version,
                             'app/js/directives/googleplaceforgenernotify.js?'+APP_VERSION.version,
                             'app/js/directives/googleplaceforkeywordnotify.js?'+APP_VERSION.version,
                             'app/js/directives/mbaddeditnotify.js?'+APP_VERSION.version,]);
                     }]
                 }
             })

             .state('user.publiccomments', {
                 url: '/public-comments',
                 templateUrl: 'app/min/public-comments.html?'+APP_VERSION.version,
                 controller: 'PublicCommentsController',
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load('app/js/controllers/PublicCommentsController.js?'+APP_VERSION.version);
                     }]
                 }
             })
             .state("user.personalizedicon", {
                 url: "/personalizedicon",
                 templateUrl: 'app/min/personalizedicon.html?'+APP_VERSION.version,
                 controller: "PersonalizedIconController",
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load([{
                             files: ['app/libs/fabric/fabric.min.js?'+APP_VERSION.version, 'app/libs/fabric/customiseControls.min.js',
                                 'app/js/controllers/PersonalizedIconController.js?'+APP_VERSION.version],
                             serie: true
                         }]);
                     }]
                 }
             })
             .state("user.mediagallery", {
                 url: "/mediagallery",
                 templateUrl: 'app/min/photogallery.html?'+APP_VERSION.version,
                 controller: "PhotoGalleryController",
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/PhotoGalleryController.js?'+APP_VERSION.version, 'app/js/controllers/VideoGalleryController.js?'+APP_VERSION.version, 'app/js/controllers/AudioGalleryController.js?'+APP_VERSION.version]);
                     }]
                 }
             })
             .state("user.audiogallery", {
                 url: "/audiogallery",
                 templateUrl: 'app/min/audiogallery2.html?'+APP_VERSION.version,
                 controller: "AudioGalleryController",
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/AudioGalleryController.js?'+APP_VERSION.version]);
                     }]
                 }
             })
             .state("user.videogallery", {
                 url: "/videogallery",
                 templateUrl: 'app/min/videogallery2.html?'+APP_VERSION.version,
                 controller: "VideoGalleryController",
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/VideoGalleryController.js?'+APP_VERSION.version]);
                     }]
                 }
             })
             .state("user.payments", {
                 url: "/payments",
                 templateUrl: 'app/min/payment.html?'+APP_VERSION.version,
                 controller: "PaymentController",
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load('app/js/controllers/PaymentController.js?'+APP_VERSION.version);
                     }]
                 }
             })
             .state("user.paymentid", {
                 url: "/payment/:id",
                 templateUrl: 'app/min/view.html?'+APP_VERSION.version,
                 controller: "PaymentController",
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load('app/js/controllers/PaymentController.js?'+APP_VERSION.version);
                     }]
                 }
             })
             .state("user.paymentsuccessslug", {
                 url: "/payment/success/:slug",
                 templateUrl: 'app/min/sucess.html?'+APP_VERSION.version,
                 controller: "PaymentController",
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load('app/js/controllers/PaymentController.js?'+APP_VERSION.version);
                     }]
                 }
             })
             .state("user.paymentserror", {
                 url: "/payments/error",
                 templateUrl: 'app/min/error.html?'+APP_VERSION.version,
                 controller: "PaymentController",
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load('app/js/controllers/PaymentController.js?'+APP_VERSION.version);
                     }]
                 }
             })
             .state("user.promotions", {
                 url: "/promotions",
                 templateUrl: 'app/min/promotions.html?'+APP_VERSION.version,
                 controller: "PromotionsController",
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load([{
                             files: ['app/js/directives/displaysettings.js?'+APP_VERSION.version,
                                 'app/js/controllers/PromotionsController.js?'+APP_VERSION.version],
                             serie: true
                         }]);
                     }],
                     getCategories: function ($http, $rootScope) {
                         $http.post('/event/getallesta').then(function (res) {
                             var data = res.data;
																		   
                             $rootScope.categories = data;
                             return data;
                         });
                     }
                 }
             })
              .state("user.addpromotion", {
                 url: "/addpromotion",
                 templateUrl: 'app/min/promotionlayout.html?'+APP_VERSION.version,
                 controller: "PromotionsController",
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load([{
                             files: ['app/js/directives/cropimage.js?'+APP_VERSION.version, "//js.braintreegateway.com/web/dropin/1.2.0/js/dropin.min.js",
                                 "//js.braintreegateway.com/web/3.17.0/js/client.min.js",
                                 'app/js/directives/displaydemo.js?'+APP_VERSION.version,
                                'app/js/controllers/PromotionsController.js?'+APP_VERSION.version,
                                 'app/js/directives/googleplaceaddress.js?'+APP_VERSION.version,
                                 'app/js/directives/mbpromotionplace.js?'+APP_VERSION.version],
                             serie: true
                         }]);
                     }],
                     getCategories: function ($http, $rootScope) {
                         $http.post('/event/getallesta').then(function (res) {
                             var data = res.data;
                             $rootScope.categories = data;
                             return data;
                         });
                     }
                 }
             })
            .state('user.advertiseinfo', {
                 url: '/advertiseinfo',
                 templateUrl: 'app/min/promotionlayoutuser.html?'+APP_VERSION.version,
                 controller: 'PromotionsController',
 				 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load(['app/js/controllers/PromotionsController.js?'+APP_VERSION.version
 						]);
                     }]
                 }
                
             })



             .state("user.wechatpaymentfailed", {
                 url: "/wechatpay_failed",
                 templateUrl: 'app/min/wechatfailed.html?'+APP_VERSION.version,
                 controller: "PromotionsController",
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load([{
                             files: ['app/js/controllers/PromotionsController.js?'+APP_VERSION.version,
                                 'app/js/directives/googleplaceaddress.js?'+APP_VERSION.version],
                             serie: true
                         }]);
                     }]
                 }
             })
             .state("user.wechatpaymentsuccess", {
                 url: "/wechatpay_success",
                 templateUrl: 'app/min/wechatsuccess.html?'+APP_VERSION.version,
                 controller: "PromotionsController",
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load([{
                             files: ['app/js/controllers/PromotionsController.js?'+APP_VERSION.version,
                                 'app/js/directives/googleplaceaddress.js?'+APP_VERSION.version],
                             serie: true
                         }]);
                     }]
                 }
             })
             .state("user.alipaypaymentfailed", {
                 url: "/alipay_failed",
                 templateUrl: 'app/min/alipayfailed.html?'+APP_VERSION.version,
                 controller: "PromotionsController",
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load([{
                             files: ['app/js/controllers/PromotionsController.js?'+APP_VERSION.version,
                                 'app/js/directives/googleplaceaddress.js?'+APP_VERSION.version],
                             serie: true
                         }]);
                     }]
                 }
             })
             .state("user.alipaypaymentsuccess", {
                 url: "/alipay_success",
                 templateUrl: 'app/min/alipaysuccess.html?'+APP_VERSION.version,
                 controller: "PromotionsController",
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load([{
                             files: ['app/js/controllers/PromotionsController.js?'+APP_VERSION.version,
                                 'app/js/directives/googleplaceaddress.js?'+APP_VERSION.version],
                             serie: true
                         }]);
                     }]
                 }
             })
             .state("user.editpromotionid", {
                 url: "/editpromotion/:id",
                 templateUrl: 'app/min/promotioneditlayout.html?'+APP_VERSION.version,
                 controller: "PromotionsController",
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load([{
                             files: ['app/js/directives/cropimage.js?'+APP_VERSION.version, "//js.braintreegateway.com/web/dropin/1.2.0/js/dropin.min.js",
                                 "//js.braintreegateway.com/web/3.17.0/js/client.min.js",
                                 'app/js/directives/displaydemo.js?'+APP_VERSION.version,
                                 'app/js/controllers/PromotionsController.js?'+APP_VERSION.version,
                                 'app/js/directives/googleplaceaddress.js?'+APP_VERSION.version,
                                 'app/js/directives/mbpromotionplace.js?'+APP_VERSION.version],
                             serie: true
                         }]);
                     }]
                 }
             })
             .state('user.promotionthankyou', {
                 url: "/promotion/thankyou/",
                 templateUrl: 'app/min/thankyou.html?'+APP_VERSION.version,
                 controller: "PromotionsController",
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load('app/js/controllers/PromotionsController.js?'+APP_VERSION.version);
                     }]
                 }
             })
             .state('user.promotionerrorp', {
                 url: "/promotion/errorp/",
                 templateUrl: 'app/min/errorp.html?'+APP_VERSION.version,
                 controller: "PromotionsController",
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', function ($ocLazyLoad) {
                         return $ocLazyLoad.load('app/js/controllers/PromotionsController.js?'+APP_VERSION.version);
                     }]
                 }
             })
             .state("user.eventgallery", {
                 url: "/eventgallery",
                 templateUrl: 'app/min/eventgallery.html?'+APP_VERSION.version,
                 controller: "EventGalleryController",
                 resolve: {
                     loadMyCtrl: ['$ocLazyLoad', "APP_VERSION", function ($ocLazyLoad, APP_VERSION) {
                         return $ocLazyLoad.load('app/js/controllers/EventGalleryController.js?'+APP_VERSION.version);
                     }]
                 }
             })
          .state('card', {
                 url: '/Mitch_St_Pierre',
                 templateUrl: 'app/min/idcardzan.html?'+APP_VERSION.version,
                 controller: 'IDCtrl',
             })
 			 .state('card2', {
                 url: '/Philip_Geatches',
                 templateUrl: 'app/min/pgeatches.html?'+APP_VERSION.version,
                 controller: 'IDCtrl',
             })

             .state('card1', {
                 url: '/brian_martin',
                 templateUrl: 'app/min/idcard.html?'+APP_VERSION.version,
                 controller: 'IDCtrl',
             });
 
         $locationProvider.html5Mode(true);

         $urlRouterProvider.otherwise('/');
     }]);
